var React = require('react');

function HFacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Fill_1","data-name":"Fill 1","d":"M26.453,0H1.544A1.546,1.546,0,0,0,0,1.546V26.453A1.546,1.546,0,0,0,1.544,28h13.41V17.156H11.308V12.93h3.647V9.815c0-3.617,2.208-5.587,5.434-5.587a30.364,30.364,0,0,1,3.26.167V8.174H21.411c-1.754,0-2.091.835-2.091,2.058v2.7H23.5l-.547,4.228H19.319V28h7.134A1.548,1.548,0,0,0,28,26.453V1.544A1.546,1.546,0,0,0,26.453,0Z","fill":"#fff"}));
}

HFacebookInline.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = HFacebookInline;

HFacebookInline.default = HFacebookInline;
